import PaymentFormContainer from "./PaymentFormContainer";

export default PaymentFormContainer;